import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import XplorerTable from '@blade-sxp/pass/components/xplorer-table.vue';
import { StaffModule } from '@blade-sxp/pass/store/staff';
import { EType } from '@blade/common/interfaces/user-group';
import AuthItem from '@blade/common/components/auth/auth-item.vue';
let default_1 = class extends Vue {
    pagination = {
        page: 1,
        size: 10,
        total: 0,
    };
    userStaff = [];
    listLoading = false;
    params = {
        dateEnd: '',
        dateStart: '',
        keywords: '',
        sort: 'DESC',
        userGroup: EType.GUEST,
    };
    handleSizeChange(size) {
        this.pagination.size = size;
        this.pagination.page = 1;
        this.getData();
    }
    handleCurrentChange(curr) {
        this.pagination.page = curr;
        this.getData();
    }
    handleFullScreen() {
        document.body.requestFullscreen();
    }
    handleRefresh() {
        this.getData();
    }
    handleCreate() {
        this.$router.push('/traffic/staff/visitor/create');
    }
    mounted() {
        this.getData();
    }
    async getData() {
        this.listLoading = true;
        try {
            const res = await StaffModule.getStaffs({ ...this.params, page: this.pagination.page, size: this.pagination.size });
            console.log('res:', res);
            const { list, total } = res.data;
            this.userStaff = list;
            this.pagination.total = total;
            this.listLoading = false;
        }
        catch (e) {
            this.listLoading = false;
        }
    }
    async handleSearch(search) {
        this.listLoading = true;
        try {
            const { keywords, ...rest } = this.params;
            const res = await StaffModule.getStaffs({ ...rest, keywords: search, page: 1, size: this.pagination.size });
            console.log('res:', res);
            const { list, total } = res.data;
            this.userStaff = list;
            this.pagination.total = total;
            this.pagination.page = 1;
            this.listLoading = false;
        }
        catch (e) {
            this.listLoading = false;
        }
    }
    handleEdit(row) {
        console.log('id:', row.libId);
        this.$router.push(`/traffic/staff/visitor/edit/${row.libId}`);
    }
    handleDelete(row) {
        if (row.currentSize > 0) {
            this.$alert('', this.$t('deleteT').toString(), {
                confirmButtonText: this.$t('confirm').toString(),
                message: this.$t('deleteW').toString(),
            });
        }
        else {
            this.$confirm(` ${row.name} ?`, 'Warning', {
                confirmButtonText: this.$t('confirm').toString(),
                cancelButtonText: this.$t('cancel').toString(),
                type: 'warning',
            })
                .then(async () => {
                try {
                    await StaffModule.deleteStaff(row.libId);
                    this.$elmessage.success(this.$t('deleted').toString());
                    this.getData();
                }
                catch (e) {
                    this.$elmessage.error(String(e));
                }
            })
                .catch(() => { });
        }
    }
    handleNameClick(val) {
        this.$emit('on-click', val.libId);
    }
};
default_1 = __decorate([
    Component({
        name: 'portrait',
        components: { AuthItem, XplorerTable },
        i18n: {
            messages: {
                'en-us': {
                    group: 'Group Name',
                    count: 'Visitor Staff Count',
                    ppl: 'Creator',
                    update: 'Update Time',
                    delete: 'Are you sure to delete ',
                    confirm: 'OK',
                    cancel: 'Cancel',
                    deleted: 'Delete successfully',
                    deleteW: 'Please deletes all visitors first',
                    deleteT: 'To Delete',
                },
                zh: {
                    group: '人员组名称',
                    count: '人员数量',
                    ppl: '创建人',
                    update: '更新时间',
                    delete: '确认删除 ',
                    confirm: '确认',
                    cancel: '取消',
                    deleted: '成功删除',
                    deleteW: '请先删除组内人员',
                    deleteT: '全部删除',
                },
            },
        },
    })
], default_1);
export default default_1;
